import { Lore } from "../types/daedalus";
import { Itter } from "../utils/utils";

const pLore =  () => Itter<Lore>(3, (i) => ({
    house: i.toString(),
    icon: "house-none.png",
    lore: null
}))

export default pLore